import {capitalize, Stack, ToggleButton, ToggleButtonGroup} from "@mui/material";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {Aufgabe} from "../../api";
import AufgabePromptVersionEditor from "./AufgabePromptVersionEditor";
import AufgabeInboundPromptVersionEditor from "./AufgabeInboundPromptVersionEditor";

export type PromptMode = 'regular' | 'inbound';

interface ToggleProps {
    mode: PromptMode;
    onChange: (mode: PromptMode) => void;
}

export function PromptModeToggle({mode, onChange}: ToggleProps) {
    const {t: translation} = useTranslation('aufgaben');
    return (
        <ToggleButtonGroup
            exclusive
            size="small"
            color="secondary"
            value={mode}
            onChange={(_, value) => { if (value) onChange(value as PromptMode); }}
        >
            <ToggleButton value="regular">{capitalize(translation('prompt-mode-regular'))}</ToggleButton>
            <ToggleButton value="inbound">{capitalize(translation('prompt-mode-inbound'))}</ToggleButton>
        </ToggleButtonGroup>
    );
}

interface Props {
    aufgabe: Aufgabe;
    canEdit: boolean;
}

export default function AufgabePromptVersionsSwitcher({aufgabe, canEdit}: Props) {
    const [mode, setMode] = useState<PromptMode>('regular');
    return (
        <Stack spacing={2}>
            <PromptModeToggle mode={mode} onChange={setMode}/>
            {mode === 'inbound'
                ? <AufgabeInboundPromptVersionEditor aufgabe={aufgabe} canEdit={canEdit}/>
                : <AufgabePromptVersionEditor aufgabe={aufgabe} canEdit={canEdit}/>}
        </Stack>
    );
}
